import React, {useEffect, useRef} from "react";
import {Button, Label} from "reactstrap";
import {IExoFilter} from "../../../../store/exo/types";
import ExoFilterRow from "./ExoFilterRow";

interface FilterListProps {
    value: IExoFilter[];
    disabled?: boolean;
    onChange: (value: IExoFilter[]) => void;
    label?: string;
}

const ExoFilterList: React.FC<FilterListProps> = ({value, disabled = false, onChange, label = "Body filters"}) => {
    const focusRef = useRef<HTMLInputElement>(null);
    const shouldFocusLast = useRef(false);

    const addFilter = () => {
        shouldFocusLast.current = true;
        onChange([...value, {key: "", values: []}]);
    }

    const updateFilter = (i: number, filter: IExoFilter) =>
        onChange(value.map((f, idx) => (idx === i ? filter : f)));

    const removeFilter = (i: number) =>
        onChange(value.filter((_, idx) => idx !== i));

    const canAddFilter = value.length === 0 || value.every(f => !!f.key && f.values.length > 0);

    useEffect(() => {
        if (shouldFocusLast.current) {
            focusRef.current?.focus();
            shouldFocusLast.current = false;
        }
    }, [value.length]);

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <Label className="mb-0">{label}</Label>
                <Button color="light" size="sm" type="button" onClick={addFilter} disabled={!canAddFilter || disabled}>
                    <i className="mdi mdi-plus me-1"></i>
                    Add filter
                </Button>
            </div>

            {value.length === 0 && <div className="text-muted small">No filters added</div>}

            {value.map((filter, i) => (
                <ExoFilterRow
                    key={i}
                    filter={filter}
                    disabled={disabled}
                    focusRef={value.length - 1 === i ? focusRef : undefined}
                    onChange={f => updateFilter(i, f)}
                    onRemove={() => removeFilter(i)}
                />
            ))}
        </div>
    );
};

export default ExoFilterList;